export default __webpack_public_path__ + "static/media/AbstractGradient.ce27627d.png";